import React from 'react';
import Accordion from '../Accordion/Accordion';
import { Button } from '../Button/Button';

import circles from '../../images/circles.svg';
import path from '../../images/path.svg';
import calendarMock from '../../images/calendar-mock-2.svg';
import scribble from '../../images/scribble.svg';
import './Tasks.scss';

const Tasks = () => (
  <div className="tasks">
    <div className="relative container">
      <h1 className="heading">
        Centralize and prioritize <br /> tasks with
        <span className="text-gradient"> ease</span>
      </h1>
      <div className="flex justify-space-between">
        <div className="col col-6 accordion-section">
          <Accordion />
          <div className="hidden-mobile">
            <Button size="md" text="Get Started" type="primary" />
          </div>
        </div>
        <div className="imageContainer hidden-mobile">
          <img className="image" src={calendarMock} alt="" />
          <img className="circles" src={circles} alt="" />
          <img className="path" src={path} alt="" />
        </div>
      </div>
      <img className="scribble hidden-mobile" src={scribble} alt="" />
    </div>
  </div>
);

export default Tasks;
